import { FacilityOfferingOperatorEnum } from '@admin/schema';

const OPERATOR_LABELS: Record<FacilityOfferingOperatorEnum, string> = {
  [FacilityOfferingOperatorEnum.Clutter]: 'Clutter',
  [FacilityOfferingOperatorEnum.Irm]: 'IRM',
};

export const OPERATOR_VALUES = Object.values(FacilityOfferingOperatorEnum);

export const operatorLabel = (value: FacilityOfferingOperatorEnum) => OPERATOR_LABELS[value];

export const DEFAULT_OPERATOR = FacilityOfferingOperatorEnum.Clutter;
